import { j as r } from "./index.es33.js";
import { t as n } from "./index.es106.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import { palette as o } from "./index.es36.js";
import { Spinner as l } from "./index.es23.js";
import { Icon as t } from "./index.es7.js";
import c from "./index.es166.js";

var v = function v(_ref) {
  var e = _ref.isLoading,
      i = _ref.isDisabled,
      m = _ref.placeholder;
  if (e) return {
    placeholderLabel: n("component_commonKeys_loadingLabel_loadingLabel"),
    SelectIcon: r.jsx(l, {
      size: 16,
      color: o.blue6
    })
  };
  var p = i ? o.gray5 : o.gray6;
  return {
    placeholderLabel: m,
    SelectIcon: r.jsx(t, {
      icon: t.icons.system.s.utilities.chevronDown,
      className: c.iconArrow,
      size: 16,
      color: p
    })
  };
};

export { v as createLabelAndIcon };